import Axios from "../baseApi";
export default {
  async fetch() {
    return await Axios.get('/api-master-data/v1/payment');
  },
  async create(data) {
    try{
      const response = await Axios.put('/api-master-data/v1/payment', data);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  async update(id, data) {
    try{
      const response = await Axios.post('/api-master-data/v1/payment/' + id, data);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  async delete(id) {
    try{
      const response = await Axios.delete('/api-master-data/v1/payment/' + id);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  }
}
